<div style="display: flex;">
    <ng-content></ng-content>
</div>